import LayersIcon from "@mui/icons-material/Layers";
import {
  Box,
  CircularProgress,
  IconButton,
  IconButtonProps,
  Tooltip,
} from "@mui/material";
import { useEventEditorContext } from "./EventEditorContext";

export interface ActivateEventsButtonProps extends IconButtonProps {}
export default function ActivateEventsButton(props: ActivateEventsButtonProps) {
  const {
    groupEventActive,
    groupEventGroupActive,
    loadingState,
    groupEditMode,
    groupActionsEnabled,
  } = useEventEditorContext();

  return (
    <Tooltip
      title={
        groupEditMode === "event"
          ? "Események aktiválása"
          : "Hajó indulás események aktiválása"
      }
    >
      <Box>
        <IconButton
          color="success"
          onClick={
            groupEditMode === "event" ? groupEventActive : groupEventGroupActive
          }
          disabled={!groupActionsEnabled}
          {...props}
        >
          {loadingState === "groupEventActive" ||
          loadingState === "groupEventGroupActive" ? (
            <CircularProgress size={16} />
          ) : (
            <LayersIcon />
          )}
        </IconButton>
      </Box>
    </Tooltip>
  );
}
